<div class="composer-menu">
  <button
    type="button"
    class="composer-menu__trigger"
    [class.composer-menu__trigger--open]="isOpen"
    (click)="toggle()"
    sgtTooltip="Adicionar arquivos e mais"
    tooltipPosition="bottom"
    aria-label="Adicionar arquivos e mais"
  >
    <i class="fas fa-plus composer-menu__trigger-icon"></i>
  </button>

  <ng-content></ng-content>

  <div class="composer-menu__panel" *ngIf="isRoot">
    <button type="button" class="composer-menu__option" (click)="openAttach()">
      <span class="composer-menu__icon" aria-hidden="true">
        <i class="fas fa-paperclip"></i>
      </span>
      <span class="composer-menu__text">
        <span class="composer-menu__label">Anexar arquivo</span>
        <span class="composer-menu__help">Do computador ou desta conversa</span>
      </span>
      <i class="fas fa-chevron-right composer-menu__drill"></i>
    </button>

    <button
      type="button"
      class="composer-menu__option"
      [disabled]="!canUseActions"
      (click)="openActions()"
    >
      <span class="composer-menu__icon" aria-hidden="true">
        <i class="fas fa-bolt"></i>
      </span>
      <span class="composer-menu__text">
        <span class="composer-menu__label">Ações</span>
        <span class="composer-menu__help">
          Cadastros, pedidos, comunicação e análises
        </span>
      </span>
      <i class="fas fa-chevron-right composer-menu__drill"></i>
    </button>
  </div>

  <div class="composer-menu__panel" *ngIf="isAttach">
    <button type="button" class="composer-menu__back" (click)="backToRoot()">
      <i class="fas fa-chevron-left"></i>
      <span>Anexar à conversa</span>
    </button>

    <button
      type="button"
      class="composer-menu__option"
      [disabled]="!canAttach"
      [attr.title]="canAttach ? null : blockedReason"
      (click)="onPickFromDevice()"
    >
      <span class="composer-menu__icon" aria-hidden="true">
        <i class="fas fa-desktop"></i>
      </span>
      <span class="composer-menu__text">
        <span class="composer-menu__label">Do meu computador</span>
        <span class="composer-menu__help">Selecionar arquivo do dispositivo</span>
      </span>
    </button>

    <button
      type="button"
      class="composer-menu__option"
      [disabled]="!canAttach || !hasConversationFiles"
      [attr.title]="canAttach ? null : blockedReason"
      (click)="onPickFromConversation()"
    >
      <span class="composer-menu__icon" aria-hidden="true">
        <i class="far fa-folder-open"></i>
      </span>
      <span class="composer-menu__text">
        <span class="composer-menu__label">Desta conversa</span>
        <span class="composer-menu__help">Reaproveitar um anexo já enviado</span>
      </span>
    </button>
  </div>
</div>
